<template>
  <div
    class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center"
    style="z-index: 1000;"
  >
    <!--
      Background overlay, show/hide based on modal state.
  
      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
    <div class="fixed inset-0 transition-opacity">
      <div class="absolute inset-0 bg-gray-500 opacity-75" @click="close"></div>
    </div>

    <!--
      Modal panel, show/hide based on modal state.
  
      Entering: "ease-out duration-300"
        From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        To: "opacity-100 translate-y-0 sm:scale-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100 translate-y-0 sm:scale-100"
        To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    -->
    <div
      class="relative bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-headline"
    >
      <div class="sm:flex sm:items-start">
        <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
          <h3
            class="text-lg leading-6 font-medium text-gray-900"
            id="modal-headline"
          >
            Send From your Number
          </h3>
          <div class="mt-2"></div>
        </div>
      </div>
      <div class="sm:ml-4 mt-4">
        <Alert
          v-if="pendingApproval && pendingApproval.phoneNumber"
          :type="'warning'"
          :text="
            'We have received your details. We will contact you over email/whatsapp  for Whatsapp API approval'
          "
        ></Alert>
        <div class="mb-6">
          <div
            v-if="!isConnected && !isLoading"
            class="text-base text-gray-600 leading-relaxed"
          >
            <p class="mb-3">
              You'll need a Facebook Business Account to proceed.
            </p>
            <div class="rounded-lg mb-4">
              <div class="flex">
                <div class="">
                  <p class="text-sm text-gray-900 font-bold">
                    Option 1: Existing WhatsApp business app Number
                  </p>
                  <p class="text-sm text-gray-700 mt-1">
                    Select the WhatsApp business existing 1st option in the
                    setup process.
                  </p>
                </div>
              </div>
            </div>
            <div class="rounded-lg">
              <div class="flex">
                <div class="">
                  <p class="text-sm text-gray-900 font-bold">
                    Option 2: Number not connected to WhatsApp
                  </p>
                  <p class="text-sm text-gray-700 mt-1">
                    Select the new number option 2nd option in the setup
                    process.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <p v-if="isConnected" class="text-base font-medium">
            Your Facebook account has been successfully connected!, It can take
            24-48 business hours depending on template approvals from WhatsApp.
            But we will expedite it and email you here {{ customerEmail }} once
            done.
          </p>

          <div
            class="Polaris-Banner Polaris-Banner--withinContentContainer mt-4"
            tabindex="0"
            role="alert"
            aria-live="polite"
            v-if="isRegistering"
          >
            <div
              class="Polaris-Box"
              style="--pc-box-color: var(--p-color-text-warning); --pc-box-background: var(--p-color-bg-surface-warning); --pc-box-border-radius: var(--p-border-radius-200); --pc-box-padding-block-start-xs: var(--p-space-200); --pc-box-padding-block-end-xs: var(--p-space-200); --pc-box-padding-inline-start-xs: var(--p-space-200); --pc-box-padding-inline-end-xs: var(--p-space-200); --pc-box-width: 100%;"
            >
              <div
                class="Polaris-InlineStack"
                style="--pc-inline-stack-align: space-between; --pc-inline-stack-block-align: start; --pc-inline-stack-wrap: nowrap; --pc-inline-stack-gap-xs: var(--p-space-200); --pc-inline-stack-flex-direction-xs: row;"
              >
                <div
                  class="Polaris-InlineStack"
                  style="--pc-inline-stack-wrap: nowrap; --pc-inline-stack-gap-xs: var(--p-space-150); --pc-inline-stack-flex-direction-xs: row;"
                >
                  <span class="Polaris-Banner__text--warning">
                    Kindly please wait we are connecting…
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div
            class="Polaris-Banner Polaris-Banner--withinContentContainer"
            tabindex="0"
            role="alert"
            aria-live="polite"
            v-if="isLoading && !isRegistering"
          >
            <div
              class="Polaris-Box"
              style="--pc-box-color: var(--p-color-text-warning); --pc-box-background: var(--p-color-bg-surface-warning); --pc-box-border-radius: var(--p-border-radius-200); --pc-box-padding-block-start-xs: var(--p-space-200); --pc-box-padding-block-end-xs: var(--p-space-200); --pc-box-padding-inline-start-xs: var(--p-space-200); --pc-box-padding-inline-end-xs: var(--p-space-200); --pc-box-width: 100%;"
            >
              <div
                class="Polaris-InlineStack"
                style="--pc-inline-stack-align: space-between; --pc-inline-stack-block-align: start; --pc-inline-stack-wrap: nowrap; --pc-inline-stack-gap-xs: var(--p-space-200); --pc-inline-stack-flex-direction-xs: row;"
              >
                <div
                  class="Polaris-InlineStack"
                  style="--pc-inline-stack-wrap: nowrap; --pc-inline-stack-gap-xs: var(--p-space-150); --pc-inline-stack-flex-direction-xs: row;"
                >
                  <span class="Polaris-Banner__text--warning">
                    <span class="Polaris-Icon">
                      <svg
                        viewBox="1 1 18 18"
                        class="Polaris-Icon__Svg"
                        focusable="false"
                        aria-hidden="true"
                      >
                        <path
                          d="M10 6.75a.75.75 0 0 1 .75.75v3.5a.75.75 0 1 1-1.5 0v-3.5a.75.75 0 0 1 .75-.75Z"
                        ></path>
                        <path d="M11 13.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"></path>
                        <path
                          fill-rule="evenodd"
                          d="M10 3.5c-1.045 0-1.784.702-2.152 1.447a449.26 449.26 0 0 1-2.005 3.847l-.028.052a403.426 403.426 0 0 0-2.008 3.856c-.372.752-.478 1.75.093 2.614.57.863 1.542 1.184 2.464 1.184h7.272c.922 0 1.895-.32 2.464-1.184.57-.864.465-1.862.093-2.614-.21-.424-1.113-2.147-2.004-3.847l-.032-.061a429.497 429.497 0 0 1-2.005-3.847c-.368-.745-1.107-1.447-2.152-1.447Zm-.808 2.112c.404-.816 1.212-.816 1.616 0 .202.409 1.112 2.145 2.022 3.88a418.904 418.904 0 0 1 2.018 3.875c.404.817 0 1.633-1.212 1.633h-7.272c-1.212 0-1.617-.816-1.212-1.633.202-.408 1.113-2.147 2.023-3.883a421.932 421.932 0 0 0 2.017-3.872Z"
                        ></path>
                      </svg>
                    </span>
                  </span>
                  <div class="Polaris-Box" style="--pc-box-width: 100%;">
                    <div
                      class="Polaris-BlockStack"
                      style="--pc-block-stack-order: column; --pc-block-stack-gap-xs: var(--p-space-200);"
                    >
                      <div
                        class="Polaris-BlockStack"
                        style="--pc-block-stack-order: column; --pc-block-stack-gap-xs: var(--p-space-050);"
                      >
                        <div>
                          <span class="Polaris-Text--root Polaris-Text--bodyMd">
                            <p>
                              Please keep this page open while we complete the
                              setup process. A popup window will appear - wait
                              until you click "Finish" there before closing this
                              page.
                            </p>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
        <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
          <button
            v-if="!isConnected && !isChecking"
            class="w-full py-2 px-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-md flex items-center justify-center transition-colors duration-300 disabled:bg-gray-400 disabled:cursor-not-allowed"
            type="button"
            @click="connectWithFacebook"
            :disabled="isLoading || isChecking"
          >
            <span v-if="isLoading">Connecting...</span>
            <span v-else class="flex items-center">
              <img
                class="w-6 h-6 mr-2"
                src="../../assets/fblogo.png"
                alt="Facebook logo"
              />
              Continue with Facebook
            </span>
          </button>
        </span>
        <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
          <button
            type="button"
            class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            @click="close"
          >
            Close
          </button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";

import Alert from "../Common/Alert.vue";

export default {
  components: {
    Alert
  },
  props: {
    feautureType: {
      type: String
    }
  },

  data() {
    return {
      isChecking: false,
      isLoading: false,
      fbSDKLoaded: false,
      isConnected: false,
      isRegistering: false,
      businessId: null,
      phoneNumberId: null,
      wabaId: null,
      code: null,
      customerEmail: "",
      pendingApproval: {}
    };
  },
  validations: {
    form: {
      phoneNumber: {
        required
      },
      contactPhoneNumber: {
        required
      },
      contactEmail: {
        required,
        email
      },
      isNumberNotConnectedToWhatsapp: {
        checked: value => value === true
      },
      hasFacebookBusinessManager: {
        checked: value => value === true
      }
    }
  },
  async mounted() {
    this.loadFacebookSDK();
    this.init();
    // Add message event listener for embedded signup
    window.addEventListener("message", this.handleFacebookMessage);

    const response = await this.$store.dispatch("getUser");
    if (response && response.user && response.user.email) {
      this.customerEmail = response.user.email;
    }
  },
  beforeDestroy() {
    // Clean up event listener when component is destroyed
    window.removeEventListener("message", this.handleFacebookMessage);
  },
  methods: {
    close() {
      if (this.isLoading) {
        alert("Facebook connection in progress, don't close the popup");
        return;
      }
      this.$emit("close");
    },
    init() {
      this.isChecking = true;
      this.$store.dispatch("getYcloudConnection").then(response => {
        this.isChecking = false;
        console.log("response", response);
        if (response.hasCustomApp === false) {
          this.isConnected = false;
        } else if (response.hasCustomApp) {
          this.isConnected = true;
        }
      });
    },
    loadFacebookSDK() {
      console.log("Attempting to load Facebook SDK");

      // Check if App ID is properly configured
      if (!process.env.VUE_APP_FACEBOOK_APP_ID) {
        console.error(
          "Facebook App ID is not configured! Please add VUE_APP_FACEBOOK_APP_ID to your .env file."
        );
        return;
      }

      // Load the Facebook SDK asynchronously
      window.fbAsyncInit = () => {
        console.log("Facebook SDK loaded successfully");
        // eslint-disable-next-line
        FB.init({
          appId: process.env.VUE_APP_FACEBOOK_APP_ID,
          cookie: true,
          xfbml: true,
          version: "v22.0"
        });

        this.fbSDKLoaded = true;
        console.log(
          "Facebook SDK initialized with App ID:",
          process.env.VUE_APP_FACEBOOK_APP_ID
        );

        // Check if user is already logged in to Facebook
        try {
          // eslint-disable-next-line
          FB.getLoginStatus(response => {
            console.log("Facebook login status:", response.status);
            if (response.status === "connected") {
              this.fetchUserInfo(response.authResponse);
            }
          });
        } catch (error) {
          console.error("Error checking Facebook login status:", error);
        }
      };

      // Load the SDK with error handling
      try {
        (function(d, s, id) {
          var js,
            fjs = d.getElementsByTagName(s)[0];
          if (d.getElementById(id)) {
            window.fbAsyncInit();
            console.log("Facebook SDK script already exists in the DOM");
            return;
          }
          js = d.createElement(s);
          js.id = id;
          js.src = "https://connect.facebook.net/en_US/sdk.js";
          // Add onload handler
          js.onload = function() {
            console.log("Facebook SDK script loaded");
          };
          // Add error handler
          js.onerror = function() {
            console.error("Failed to load Facebook SDK");
          };
          fjs.parentNode.insertBefore(js, fjs);
          console.log("Facebook SDK script added to DOM");
        })(document, "script", "facebook-jssdk");
      } catch (error) {
        console.error("Error loading Facebook SDK:", error);
      }
    },

    connectWithFacebook() {
      if (!this.fbSDKLoaded) {
        console.error("Facebook SDK not loaded");
        // Try to reload the SDK
        this.loadFacebookSDK();
        alert(
          "Facebook integration is not available right now. Please try again later."
        );
        return;
      }

      this.isLoading = true;
      // eslint-disable-next-line
      FB.login(
        response => {
          if (response.authResponse) {
            this.fetchUserInfo(response.authResponse);
          } else {
            console.log("User cancelled login or did not fully authorize.");
            this.isLoading = false;
          }
        },
        // Using the configuration-based approach
        {
          config_id: process.env.VUE_APP_FB_CONFIGURATION_ID,
          response_type: "code",
          override_default_response_type: true,
          extras: {
            setup: {
              solutionID: process.env.VUE_APP_FB_SOLUTION_ID
            },
            // featureType: "",
            featureType: "whatsapp_business_app_onboarding",
            sessionInfoVersion: "3"
          }
        }
      );
    },

    fetchUserInfo(authResponse) {
      // Check if we're dealing with a code-based response
      if (authResponse.code) {
        // Handle the code-based response
        this.handleFacebookAuthSuccess(authResponse);
        return;
      }
    },

    handleFacebookMessage(event) {
      // Verify the origin is from Facebook domains
      if (
        event.origin !== "https://www.facebook.com" &&
        event.origin !== "https://web.facebook.com"
      )
        return;

      console.log("Received message from Facebook:", event);

      try {
        const data =
          typeof event.data === "string" ? JSON.parse(event.data) : event.data;

        if (data.type === "WA_EMBEDDED_SIGNUP") {
          console.log("Facebook embedded signup message:", data);

          // Handle the signup response
          if (data.data && data.data.phone_number_id && data.data.waba_id) {
            // Success case - user authorized the app
            this.phoneNumberId = data.data.phone_number_id;
            this.wabaId = data.data.waba_id;
            this.businessId = data.data.business_id;
            this.isRegistering = true;
            this.registerPhoneNumber();
          } else if (data.data && data.data.waba_id && data.data.business_id) {
            // Success case - user authorized the app
            this.wabaId = data.data.waba_id;
            this.businessId = data.data.business_id;
            this.isRegistering = true;
            this.registerWabaApp();
          } else if (data.error) {
            // Error case - handle appropriately
            console.error("Facebook signup error:", data.error);
            this.isLoading = false;

            // Show error message to user
            alert(
              `Facebook signup failed: ${data.error_description || data.error}`
            );
          }
        }
      } catch (error) {
        console.error("Error processing Facebook message:", error);
        console.log("Raw message data:", event.data);
        this.isLoading = false;
      }
    },

    handleFacebookAuthSuccess(data) {
      console.log("Facebook auth successful, code received", data.code);

      this.code = data.code;
    },

    registerPhoneNumber() {
      this.sendInitiationMessage(this.wabaId);
      this.$store
        .dispatch("registerYcloudPhoneNumber", {
          requestParams: {
            phoneNumberId: this.phoneNumberId,
            wabaId: this.wabaId,
            businessId: this.businessId,
            code: this.code
          }
        })
        .then(response => {
          console.log(response);
          this.isConnected = true;
          this.isLoading = false;
          this.isRegistering = false;
          this.sendToCrisp();
        })
        .catch(err => {
          this.isConnected = true;
          this.isLoading = false;
          this.isRegistering = false;
          console.error(err);
        });
    },
    registerWabaApp() {
      this.sendInitiationMessage(this.wabaId);
      this.$store
        .dispatch("registerYcloudWabaApp", {
          requestParams: {
            wabaId: this.wabaId,
            businessId: this.businessId
          }
        })
        .then(response => {
          console.log(response);
          this.isLoading = false;
          this.isRegistering = false;
          this.isConnected = true;
          this.sendToCrisp();
        })
        .catch(err => {
          this.isConnected = true;
          this.isLoading = false;
          this.isRegistering = false;
          console.error(err);
        });
    },

    openManageTemplates() {
      window.open(
        `https://business.facebook.com/latest/whatsapp_manager/message_templates?business_id=${this.businessId}&asset_id=${this.wabaId}`,
        "_blank"
      );
    },

    sendToCrisp() {
      // $crisp.push(["do", "chat:open"]); // eslint-disable-line
      // eslint-disable-next-line
      $crisp.push([
        "do",
        "message:send",
        [
          "text",
          `WhatsApp Business API Connected: \n\n Business ID: ${this.businessId}\n\n WABA ID: ${this.wabaId} \n\n Phone Number ID: ${this.phoneNumberId}`
        ]
      ]);
    },
    sendInitiationMessage(wabaId) {
      // eslint-disable-next-line
      $crisp.push([
        "do",
        "message:send",
        [
          "text",
          `WhatsApp Business API Connection Intiated: \n\n WABA ID: ${wabaId} `
        ]
      ]);
    }
  }
};
</script>

<style lang="scss" scoped></style>
